import { createFileRoute } from "@tanstack/react-router";
import PtsdKetaminePage from "@/pages/PtsdKetaminePage";
import { buildConditionSchema } from "@/components/ConditionPageLayout";
export const Route = createFileRoute("/ptsd-treatment-coral-springs-fl")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Ptsd Treatment Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "PTSD treatment in Coral Springs, FL. Prism neurofeedback, therapy, and medication management for post-traumatic stress at Neuro Wellness TMS.",
        },
        {
          property: "og:title",
          content: "Ptsd Treatment Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "PTSD treatment in Coral Springs, FL. Prism neurofeedback, therapy, and medication management for post-traumatic stress at Neuro Wellness TMS.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/ptsd-treatment-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/ptsd-treatment-coral-springs-fl",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            buildConditionSchema({
              seoTitle:
                "Ketamine for PTSD Treatment Coral Springs, FL | Neuro Wellness TMS Centers of America",
              seoDescription:
                "Rapid relief from PTSD flashbacks, trauma reactivity, and hypervigilance with IV Ketamine therapy at Neuro Wellness TMS Centers in Coral Springs, FL.",
              canonical: "/ptsd-treatment-coral-springs-fl",
              breadcrumbs: [
                { name: "Services", href: "/services-directory" },
                {
                  name: "Conditions Treated",
                  href: "/ketamine-treatment-coral-springs-fl",
                },
                { name: "PTSD", href: "/ptsd-treatment-coral-springs-fl" },
              ],
            }),
          ),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <PtsdKetaminePage />;
}
